import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CTABanner from './components/CTABanner';
import ArticleSection from './components/ArticleSection';
import ProductScroll from './components/ProductScroll';
import ArticlePreviews from './components/ArticlePreviews';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <CategoryGrid />
      <CTABanner />
      <ArticleSection />
      <ProductScroll />
      <ArticlePreviews />
      <Testimonials />
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "name": "OOPBUY Spreadsheet Deutschland",
                "url": "https://oopbuyspread.baby",
                "description": "Die unabhängige deutsche Informationsplattform für OOPBUY Spreadsheet, Produktlisten, Verkäufer und Shopping-Tipps.",
                "inLanguage": "de",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://oopbuyspread.baby/search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              },
              {
                "@type": "Organization",
                "name": "OOPBUY Spreadsheet Deutschland",
                "url": "https://oopbuyspread.baby",
                "description": "Die unabhängige deutsche Informationsplattform für OOPBUY Spreadsheet, Produktlisten, QC, Verkäufer und Versand.",
                "email": "info@oopbuyspread.baby",
                "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg",
                "foundingDate": "2026",
                "areaServed": [
                  { "@type": "Country", "name": "Deutschland" },
                  { "@type": "Country", "name": "Österreich" },
                  { "@type": "Country", "name": "Schweiz" }
                ]
              }
            ]
          })
        }}
      />
    </div>
  );
}